import React from 'react';
import { Grid } from '@mui/material';

interface UserProfileProps {
    fullName: string;
}
export default function UserProfile(props: UserProfileProps) {
    console.log(props);
    const fullName = localStorage.getItem('fullName');
    const [accessArr, setAccessArr] = React.useState<(string|undefined)[]>([]);
    const profileArr = [
        {
            label: 'First Name',
            value: fullName?.split('.')[0]
        },
        {
            label: 'Last Name',
            value: fullName?.split('.')[1]
        },
        {
            label: 'Last login date',
            value: localStorage.getItem('loginTime')
        },
        // {
        //     label: 'Access',
        //     value: accessArr?.join(',')
        // },
    ];
    // React.useEffect(() => {
    //     async function getGroupDetails() {
    //         const username = localStorage.getItem('userName');
    //         if (username) {
    //             const g = await AdminService.getGroupsForUser(username);
    //             const groupArr = g.map(gx => gx.GroupName);
    //             setAccessArr(groupArr);
    //         }
    //     }
    //     getGroupDetails();
    // }, [])
    return (
        <>
            {accessArr.length > 0 && <Grid container justifyContent="space-evenly">
                {
                    profileArr.map(profileObj => <>
                        <Grid item md={4}>
                            {profileObj.label}
                        </Grid>
                        <Grid item md={8}>
                            {profileObj.value}
                        </Grid>
                    </>)
                }
            </Grid>}
        </>
    )
}